"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cityList = cityList;
exports.bdList = bdList;
exports.deleteBD = deleteBD;
exports.saveBD = saveBD;
exports.getSource = getSource;
exports.saveSource = saveSource;
exports.deleteSource = deleteSource;
exports.addGroupMember = addGroupMember;
exports.deleteGroup = deleteGroup;
exports.deleteGroupMember = deleteGroupMember;
exports.groupList = groupList;
exports.saveGroup = saveGroup;
exports.updateGroupLeader = updateGroupLeader;
exports.updateGroupMemberLimit = updateGroupMemberLimit;

var _request = _interopRequireDefault(require("@/utils/request"));

// GET /baseConfig/cityList
function cityList(query) {
  return (0, _request.default)({
    url: '/baseConfig/cityList',
    method: 'get',
    params: query
  });
} // GET /baseConfig/bdList


function bdList(query) {
  return (0, _request.default)({
    url: '/baseConfig/bdList',
    method: 'get',
    params: query
  });
} // GET /baseConfig/deleteBD


function deleteBD(query) {
  return (0, _request.default)({
    url: '/baseConfig/deleteBD',
    method: 'get',
    params: query
  });
} // POST /baseConfig/saveBD


function saveBD(data) {
  return (0, _request.default)({
    url: '/baseConfig/saveBD',
    method: 'post',
    data: data
  });
} // GET /baseConfig/getSource


function getSource(query) {
  return (0, _request.default)({
    url: '/baseConfig/getSource',
    method: 'get',
    params: query
  });
} // POST /baseConfig/saveSource


function saveSource(data) {
  return (0, _request.default)({
    url: '/baseConfig/saveSource',
    method: 'post',
    data: data
  });
} // GET /baseConfig/deleteSource


function deleteSource(query) {
  return (0, _request.default)({
    url: '/baseConfig/deleteSource',
    method: 'get',
    params: query
  });
} // POST /baseConfig/addGroupMember


function addGroupMember(data) {
  return (0, _request.default)({
    url: '/baseConfig/addGroupMember',
    method: 'post',
    data: data
  });
} // GET /baseConfig/deleteGroup


function deleteGroup(query) {
  return (0, _request.default)({
    url: '/baseConfig/deleteGroup',
    method: 'get',
    params: query
  });
} // POST /baseConfig/deleteGroupMember


function deleteGroupMember(data) {
  return (0, _request.default)({
    url: '/baseConfig/deleteGroupMember',
    method: 'post',
    data: data
  });
} // POST /baseConfig/groupList


function groupList(data) {
  return (0, _request.default)({
    url: '/baseConfig/groupList',
    method: 'post',
    data: data
  });
} // POST /baseConfig/saveGroup


function saveGroup(data) {
  return (0, _request.default)({
    url: '/baseConfig/saveGroup',
    method: 'post',
    data: data
  });
} // POST /baseConfig/updateGroupLeader


function updateGroupLeader(data) {
  return (0, _request.default)({
    url: '/baseConfig/updateGroupLeader',
    method: 'post',
    data: data
  });
} // GET /baseConfig/updateGroupMemberLimit


function updateGroupMemberLimit(query) {
  return (0, _request.default)({
    url: '/baseConfig/updateGroupMemberLimit',
    method: 'get',
    params: query
  });
}